import React, { useEffect } from 'react';
import { Warning, X, CaretRight } from '@phosphor-icons/react';

export default function NotificationToasts({ breaches, onDismiss, onDismissAll }) {
  // Auto-dismiss after 10 seconds
  useEffect(() => {
    if (breaches.length === 0) return;
    const timer = setTimeout(() => {
      onDismissAll();
    }, 10000);
    return () => clearTimeout(timer);
  }, [breaches, onDismissAll]);

  if (breaches.length === 0) return null;

  return (
    <div
      data-testid="notification-toasts"
      className="fixed top-20 right-4 z-[60] space-y-2 max-w-sm w-full pointer-events-none"
    >
      {breaches.slice(0, 3).map((notif, i) => {
        const isCritical = notif.severity === 'critical';
        return (
          <div
            key={notif._id || i}
            className={`pointer-events-auto rounded-lg border shadow-lg p-3 animate-slide-in ${
              isCritical
                ? 'bg-alert-critical/95 border-alert-critical/50 text-white'
                : 'bg-surface border-alert-warning/40'
            }`}
            style={{ animationDelay: `${i * 100}ms` }}
            data-testid={`toast-${notif._id || i}`}
          >
            <div className="flex items-start gap-2.5">
              <Warning
                size={18}
                weight="fill"
                className={isCritical ? 'text-white mt-0.5' : 'text-alert-warning mt-0.5'}
              />
              <div className="flex-1 min-w-0">
                <p className={`font-body text-xs font-semibold leading-snug ${isCritical ? 'text-white' : 'text-text-primary'}`}>
                  {notif.title}
                </p>
                <div className="flex items-center gap-1 mt-1">
                  <span className={`w-1.5 h-1.5 rounded-full ${notif.previous_status === 'green' ? 'bg-success' : isCritical ? 'bg-white/60' : 'bg-alert-warning'}`} />
                  <CaretRight size={8} className={isCritical ? 'text-white/60' : 'text-tertiary'} />
                  <span className={`w-1.5 h-1.5 rounded-full ${notif.new_status === 'red' ? (isCritical ? 'bg-white' : 'bg-alert-critical') : 'bg-alert-warning'}`} />
                  <span className={`text-[10px] font-body ${isCritical ? 'text-white/80' : 'text-text-secondary'}`}>
                    {notif.site} — {notif.metric_label}
                  </span>
                </div>
              </div>
              <button
                onClick={() => onDismiss(notif._id)}
                className={`p-1 rounded-md transition-colors flex-shrink-0 ${
                  isCritical ? 'hover:bg-white/20' : 'hover:bg-background'
                }`}
              >
                <X size={12} className={isCritical ? 'text-white/80' : 'text-tertiary'} />
              </button>
            </div>
          </div>
        );
      })}

      {breaches.length > 3 && (
        <div className="pointer-events-auto text-center">
          <span className="inline-block px-3 py-1 bg-surface border border-border rounded-full text-[10px] font-body font-medium text-text-secondary shadow-sm">
            +{breaches.length - 3} more notifications
          </span>
        </div>
      )}
    </div>
  );
}
